import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/api.js';

// API paths
const API_PATHS = {
  DASHBOARD: '/dashboard',
};

// Thunk for fetching dashboard data
export const fetchDashboard = createAsyncThunk('dashboard/fetchDashboard', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get(API_PATHS.DASHBOARD);
    // The API returns S3 data that might need parsing
    return typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard data');
  }
});

// Initial state
const initialState = {
  dashboardData: null,
  loading: 'idle', // 'idle' | 'pending' | 'succeeded' | 'failed'
  error: null,
};

// Create the slice
const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // Add any additional synchronous reducers here
  },
  extraReducers: (builder) => {
    // Handle fetchDashboard
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
        state.loading = false;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.loading = true;
        state.error = action.payload;
      });
  },
});

// Export selectors
export const selectDashboardData = (state) => state.dashboard.dashboardData;
export const selectDashboardLoading = (state) => state.dashboard.loading;
export const selectDashboardError = (state) => state.dashboard.error;

export default dashboardSlice.reducer;
